import api from "../axiosIntercepture";

const BASE = "ratecard";

export const createRateCard = async (payload) => {
  try {
    const response = await api.post(`${BASE}/create`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error creating rate card:", err);
    throw err?.response?.data?.message || "Failed to create rate card";
  }
};

export const getAllRateCards = async () => {
  try {
    const response = await api.get(`${BASE}/list`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? [];
  } catch (err) {
    console.error("Error fetching rate cards:", err);
    throw err?.response?.data?.message || "Failed to fetch rate cards";
  }
};

export const getRateCardById = async (id) => {
  try {
    const response = await api.get(`${BASE}/${id}`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? null;
  } catch (err) {
    console.error("Error fetching rate card:", err);
    throw err?.response?.data?.message || "Failed to fetch rate card";
  }
};

export const updateRateCard = async (id, payload) => {
  try {
    const response = await api.put(`${BASE}/update/${id}`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error updating rate card:", err);
    throw err?.response?.data?.message || "Failed to update rate card";
  }
};

export const deleteRateCard = async (id) => {
  try {
    const response = await api.delete(`${BASE}/delete/${id}`);
    if (response.data?.success) {
      return response.data.data;
    }
    return response.data;
  } catch (err) {
    console.error("Error deleting rate card:", err);
    throw err?.response?.data?.message || "Failed to delete rate card";
  }
};
